import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const MoonFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="moonFilled" ref={ref} {...props}>
      <path d="M21.51,17a11.29,11.29,0,0,1-2.78,2.61,11,11,0,0,1-6,1.81,9.76,9.76,0,0,1-8.26-4.33C1.46,12.54,3,6.23,7.86,3A11,11,0,0,1,11,1.62a.74.74,0,0,1,.84.35.73.73,0,0,1-.11.9,8,8,0,0,0,5.7,13.68,8,8,0,0,0,3.18-.66.76.76,0,0,1,.89.23A.75.75,0,0,1,21.51,17Z" />
    </Icon>
  ),
) as IconWithRender;

MoonFilledIcon.displayName = 'MoonFilledIcon';
MoonFilledIcon.renderIcon = (props) => <MoonFilledIcon {...props} />;
export default MoonFilledIcon;
